import React, { Component } from 'react';
import {connect} from 'react-redux';
import CategoryItem from './CategoryItem.jsx';
import {setDataBreadCrumb} from 'actions';

class AllCategoriesContainer extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hasBreadcrumb: true
    };
  }

  componentDidMount() {
    let breadcrumb = [
      {name: 'Trang chủ', link: '/'},
      {name: 'Sản phẩm'}
    ]
    this.props.dispatch(setDataBreadCrumb(this.state.hasBreadcrumb, breadcrumb));
  }

  render() {
    return (
      <div className='category-S-left-list-wrapper'>
        <div className='category-S-left-list-row'>
        {
          this.props.categories.map((item, i) => {
            return (
              <CategoryItem key={i} {...item}/>
            )
          })
        }
        </div>
      </div>
    );
  }

}

let bindStateToProps = (state) => {
  return {
    categories: state.categoriesAsTree
  }
}

export default connect(bindStateToProps)(AllCategoriesContainer);



// WEBPACK FOOTER //
// ./components/all-categories/AllCategoriesContainer.jsx